import Alpine from "alpinejs"
import validate from "../validations"
import { load, store } from "../localStorage"
import testView from "./02-test"
import privacyView from "./03-test"
import firstNameView from "./04-test"
import heightView from "./06-test"
import weightView from "./07-test"
import idealWeightView from "./08-test"
import ageView from "./09-test"
import checkboxView from "./23-test"
import bodyPartsView from "./54-test"
import resultsView from "./60-results"
import primerView from "./primer"

const LOCAL_STORAGE_KEY = "view"
const GLOBAL_STORAGE_KEY = "data"

const view = (nextStepPath) => ({
  showButton: false,
  formValues: {},
  errors: {},

  init() {
    this.store = Alpine.store("data")
    const data = load(LOCAL_STORAGE_KEY)

    if (this.onInit) this.onInit(data)

    if (data && data.errors && data.path === window.location.pathname) {
      this.formValues = data.formValues
      this.errors = data.errors
      this.showButton = true
    }
  },

  getButtonState() {
    this.showButton = Object.values(this.formValues).every((v) => !!v || v === 0)
  },

  populateFormValuesFromStorage(values) {
    const globalData = load(GLOBAL_STORAGE_KEY)
    values.map((value) => {
      const globalMatch = globalData.values[value]

      if (!globalMatch) return

      this.formValues[value] = globalMatch
    })

    this.getButtonState()
  },

  update(field, value) {
    this.formValues[field] = value
    this.submit()
  },

  justUpdate(field, value) {
    this.formValues[field] = value
  },

  processFormValues() {
    return this.formValues
  },

  getNextStepPath() {
    return nextStepPath
  },

  get isValid() {
    return !Object.values(this.errors).some(Boolean)
  },

  async submit() {
    const formValues = this.processFormValues()

    const { hasErrors, errors } = validate(formValues)

    if (hasErrors) {
      this.errors = errors
    } else {
      this.store.values = { ...this.store.values, ...formValues }

      if (await this.store.push()) {
        window.location = this.getNextStepPath()
      }
    }
  },
})

export default [
  { name: "view", data: view },
  { name: "testView", data: testView(view) },
  { name: "privacyView", data: privacyView(view) },
  { name: "firstNameView", data: firstNameView(view) },
  { name: "heightView", data: heightView(view) },
  { name: "weightView", data: weightView(view) },
  { name: "idealWeightView", data: idealWeightView(view) },
  { name: "ageView", data: ageView(view) },
  { name: "checkboxView", data: checkboxView(view) },
  { name: "bodyPartsView", data: bodyPartsView(view) },
  { name: "resultsView", data: resultsView(view) },
  { name: "primerView", data: primerView(view) },
]
